import { render, staticRenderFns } from "./ClassGroup.vue?vue&type=template&id=7ef4298e&scoped=true&"
import script from "./ClassGroup.vue?vue&type=script&lang=js&"
export * from "./ClassGroup.vue?vue&type=script&lang=js&"
import style0 from "./ClassGroup.vue?vue&type=style&index=0&id=7ef4298e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4298e",
  null
  
)

export default component.exports